// import React, { useState } from "react";
// import { Link } from "react-router-dom";
// import logo from "../images/Apex-png.png";
// import "../styles/header.css";

// function Header() {
//   const [menuOpen, setMenuOpen] = useState(false);

//   return (
//     <>
//       {/* TOP CONTACT BAR */}
//       <div className="top-bar">
//         <div className="container top-bar-flex">
//           <div className="top-item">
//             <i className="fa fa-phone"></i>
//             <span>+971 58 573 5792</span>
//           </div>

//           <div className="top-item">
//             <i className="fa fa-envelope"></i>
//             <span>info@apextrade.ae</span>
//           </div>
//         </div>
//       </div>

//       {/* MAIN HEADER */}
//       <header className="header">
//         <div className="container header-flex">

//           {/* LOGO + COMPANY NAME */}
//           <div className="logo-area">
//             <img src={logo} alt="Apex Trade Connect Logo" className="logo-img" />
//             <span className="company-name">Apex Trade Connect</span>
//           </div>

//           {/* NAVIGATION */}
//           <nav className={`nav ${menuOpen ? "open" : ""}`}>
//             <Link className="nav-link" to="/" onClick={() => setMenuOpen(false)}>Home</Link>
//             <Link className="nav-link" to="/about" onClick={() => setMenuOpen(false)}>About Us</Link>
//             <Link className="nav-link" to="/products" onClick={() => setMenuOpen(false)}>Products</Link>
//             <Link
//               to="/contact"
//               className="btn btn-primary inquiry-btn"
//               onClick={() => setMenuOpen(false)}
//             >
//               Inquiry
//             </Link>
//           </nav>

//           {/* MOBILE MENU */}
//           <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
//             ☰
//           </div>
//         </div>
//       </header>
//     </>
//   );
// }

// export default Header;


import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import logo from "../images/Apex-png.png";
import "../styles/header.css";

function Header() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  /* Shrink header on scroll */
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* TOP CONTACT BAR */}
      <div className="top-bar">
        <div className="container top-bar-flex">

          <a href="tel:+971585735792" className="top-item">
            <i className="fa fa-phone"></i>
            <span>+971 58 573 5792</span>
          </a>

          <a href="mailto:info@apextrade.ae" className="top-item">
            <i className="fa fa-envelope"></i>
            <span>info@apextrade.ae</span>
          </a>

        </div>
      </div>

      {/* MAIN HEADER */}
      <header className={`header ${scrolled ? "shrink" : ""}`}>
        <div className="container header-flex">

          {/* LOGO */}
          <div className="logo-area">
            <img src={logo} alt="Apex Trade Connect Logo" className="logo-img" />
            <span className="company-name">Apex Trade Connect</span>
          </div>

          {/* NAV */}
          <nav className={`nav ${menuOpen ? "open" : ""}`}>
            <NavLink to="/" end className="nav-link" onClick={() => setMenuOpen(false)}>
              Home
            </NavLink>

            <NavLink to="/about" className="nav-link" onClick={() => setMenuOpen(false)}>
              About Us
            </NavLink>

            <NavLink to="/products" className="nav-link" onClick={() => setMenuOpen(false)}>
              Products
            </NavLink>

            <NavLink
              to="/contact"
              className="btn btn-primary inquiry-btn"
              onClick={() => setMenuOpen(false)}
            >
              Inquiry
            </NavLink>
          </nav>

          {/* MOBILE MENU ICON */}
          <div className="menu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
            ☰
          </div>
        </div>
      </header>
    </>
  );
}

export default Header;
